<template>
    <div class="Frt-Cadastro-Principal">
        <PageTitle icon="fa fa-group" main="Cadastro"
            sub="Cadastro -> Frota / Fabricantes / Chassi" />
        <div class="Fol-Cadastro-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Frota" active><Frota /></b-tab>                                                                                                                                                                                                                                                                                                                                                                                                              
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import Frota from '../despachante/Frota'


export default {
    name: 'FrotaPrincipal',    
    components: { PageTitle, Frota }
    
}
</script>

<style>

</style>






